import React, { useState } from 'react';
import ListItem from './ListItem';
import Pagination2 from '../../../components/Pagination2';
import generateClassName from '../../../utils/generateClassName';

const CafeDiscountsList = props => {
  const { sortType } = props;
  const [sortedColumn, setSortedColumn] = useState(' ');

  const sortTable = query => {
    setSortedColumn(query);
    props.sortTable(query);
  };

  return (
    <>
      <table className="table table-hover table-light table-striped">
        <thead className="thead-dark">
          <tr>
            <th className="text-center">{locales('labels.row')}</th>
            <th onClick={() => sortTable('fromDate')} className="text-center pointer">
              <i name="fromDate" className={generateClassName('fromDate', sortedColumn, sortType)} />
              {locales('labels.from.date')}
            </th>
            <th onClick={() => sortTable('toDate')} className="text-center pointer">
              <i name="toDate" className={generateClassName('toDate', sortedColumn, sortType)} />
              {locales('labels.to.date')}
            </th>
            <th className="text-center">{locales('labels.status')}</th>
            <th onClick={() => sortTable('createdAt')} className="text-center pointer">
              <i name="createdAt" className={generateClassName('createdAt', sortedColumn, sortType)} />
              {locales('labels.request.date.time')}
            </th>
            <th className="text-center"></th>
          </tr>
        </thead>
        <tbody>
          {props.myCafeDiscountsList && props.myCafeDiscountsList.length ? (
            props.myCafeDiscountsList.map((cafeDiscountListItem, ix) => (
              <ListItem
                key={cafeDiscountListItem.id}
                id={cafeDiscountListItem.id}
                ix={ix}
                fromDate={cafeDiscountListItem.fromDate}
                toDate={cafeDiscountListItem.toDate}
                status={cafeDiscountListItem.status}
                createdAt={cafeDiscountListItem.createdAt}
                pageNumber={props.pageNumber}
                pageSize={props.pageSize}
              />
            ))
          ) : (
            <tr className="text-center">
              <td className="alert alert-info" colSpan="12">
                {locales('alerts.noRecord')}
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <footer className="d-flex justify-content-center">
        <div className="pagination-container">
          <Pagination2
            totalRecords={props.totalRecords}
            pageLimit={props.pageSize}
            pageNeighbours={2}
            onPageChanged={props.onPageChange}
            currentPage={props.pageNumber}
          />
        </div>
      </footer>
    </>
  );
};

export default CafeDiscountsList;
